import * as React from 'react';
import { connect } from 'react-redux';
import './ClaimInfo.css';
import { showCallMeModal } from '../../../actions/modalActions';

class ClaimInfo extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
        };
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
    }

    handleCallMeBack(e: any) {
        this.props.handleCallMeBack();
    }

    getClaimStatusClass(claimStatus) {

        let cssClass = '';

        switch (claimStatus) {
            case 'Approved': cssClass = 'Approved'
                break;
            case 'Not approved': cssClass = 'Cancelled';
                break;

            case 'Pending': cssClass = 'Pending';
                break;

            case 'Unknown': cssClass = 'hidden';
                break;

            default: cssClass = 'hidden';
        }
        return cssClass;
    }

    public render() {
        return (
            <>
                <div id="ClaimInfoCard">
                    <div className="pl-0 pb-lg-3">
                        <div className="box col-12">
                            <div className="row">
                                <div className="col-6 col-lg-4 mt-5 claim-info-line">
                                    <p className="small-text-top">Incident date:<br className="d-lg-none" /> <b>{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.incidentDate}</b></p>
                                </div>

                                <div className="col-6 col-lg-4 mt-5">
                                    <p className="small-text-top">Claim submitted: <br className="d-lg-none" /><b>{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.claimRegisteredDate}</b></p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <h3 className="mt-3 mt-md-0">{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.claimTitle}</h3>
                                    <p className="claim-details">{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.riskItem}</p>
                                    <p className="claim-details">{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.incident}</p>
                                    <p className="claim-details">Claim no. <b>{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.claimNumber}</b></p>

                                    <div className="row ml-1">
                                   
                                        <div className={this.props.profile.selectedPersonalClaim !== "" &&
                                            this.props.profile.selectedPersonalClaim.claimStatus !== "" ?
                                            'dot mt-0 ' + this.props.profile.selectedPersonalClaim.claimStatus : ''}></div>
                                      &nbsp;  &nbsp;
                                    <p className={this.props.profile.selectedPersonalClaim !== "" &&
                                            this.props.profile.selectedPersonalClaim.claimStatus !== "" ?
                                            this.props.profile.selectedPersonalClaim.claimStatus + '-color status-heading' : ''} >
                                            {this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.claimStatus}</p>
                                    
                                    </div>
                                </div>
                            </div>

                            <hr />
                            
                            <div className="row">
                                <b className="col-lg-6 col-12 mb-1">Excess amount</b>
                                <p className="col-lg-6 col-12 red-excess text-lg-right">{this.props.profile.selectedPersonalClaim && ((this.props.profile.selectedPersonalClaim.claimStatus === "Unknown" && this.props.profile.selectedPersonalClaim.totalExcess === 0) ? "TBD" :  this.props.profile.currencySymbol + this.props.profile.selectedPersonalClaim.totalExcess) }</p>
                            </div>
                            <hr />
                            <div className="row">
                                <b className="col-lg-6 col-12 mb-1">Type of incident</b>
                                <p className="col-lg-6 col-12 text-lg-right">{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.incidentType}</p>
                            </div>
                            <hr />

                            <div className="row">
                                <b className="col-lg-6 col-12 mb-1">Incident</b>
                                <p className="col-lg-6 col-12  text-lg-right">{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.incident}</p>
                            </div>
                            <hr />

                            <div className="row">
                                <b className="col-lg-6 col-12 mb-1">Damage report</b>
                                {this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.damageReports[0] !== "" &&
                                    <p className="col-lg-6 col-12  text-lg-right">{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.damageReports[0]}</p>
                                }
                                {this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.damageReports[0] === "" &&
                                    <p className="col-lg-6 col-12  text-lg-right">N/A</p>
                                }
                            </div>
                            <hr />

                            <div className="row">
                                <b className="col-lg-6 col-12 mb-1">Does your window have smash and grab</b>
                                {this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.smashAndGrab &&
                                     <p className="col-lg-6 col-12 text-lg-right"><b>Yes</b></p>
                                }
                                {this.props.profile.selectedPersonalClaim !== "" && !this.props.profile.selectedPersonalClaim.smashAndGrab &&
                                     <p className="col-lg-6 col-12 text-lg-right">Yes</p>
                                }
                            </div>
                            <hr />

                            <div className="row">
                                <b className="col-lg-6 col-12 mb-1">Can it be repaired</b>
                                {this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.alreadyRepairedOrReplaced &&
                                    <p className="col-lg-6 col-12 text-lg-right">Yes</p>
                                }
                                {this.props.profile.selectedPersonalClaim !== "" && !this.props.profile.selectedPersonalClaim.alreadyRepairedOrReplaced &&
                                    <p className="col-lg-6 col-12 text-lg-right">Yes</p>
                                }
                            </div>
                            <hr />

                            <div className="row">
                                <b className="col-lg-6 col-12 mb-1">Supplier</b>
                                {this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.suppliers[0] !== undefined && this.props.profile.selectedPersonalClaim.suppliers[0] !== "" &&
                                    <p className="col-lg-6 col-12 text-lg-right">{this.props.profile.selectedPersonalClaim.suppliers[0].name}</p>
                                }
                                {this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.suppliers[0] === "" &&
                                    <p className="col-lg-6 col-12 text-lg-right">N/A</p>
                                }
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        firebase: state.firebase,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimInfo);